class tableFilter {
    constructor(sortBy = '', sortDir = true, page = 1, pageSize = 10, startDate = null, finishDate = null, searchData = []) {
        this.sortBy = sortBy;
        this.sortDir = sortDir;
        this.page = page;
        this.pageSize = pageSize;
        this.startDate = startDate;
        this.finishDate = finishDate;
        this.searchData = searchData;
    }
    stringfy() {
        return JSON.stringify(this);
    }
}
export default tableFilter;
//# sourceMappingURL=tableFilter.js.map